




































import { upload } from "@/services/upload.service";
import { Component, Vue, Prop } from "vue-property-decorator";
import { AxiosResponse, AxiosError } from "axios";
import axios from "axios";
@Component
export default class AddMembersView extends Vue {
  isLoading = false;
  fileName = "";
  get conference() {
    return this.$store.getters.getConferenceId;
  }

  onFileChange(e: Event) {
    if (e && e.target) {
      this.isLoading = true;
      const formData = new FormData();
      // @ts-ignore
      const fileList = e.target.files;
      // @ts-ignore
      const fieldName = e.target.name;
      if (!fileList.length) {
        return;
      }
      this.fileName = fileList[0].name;
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      formData.append("conference", this.conference);
      this.save(
        formData,
        "https://admin-nanomat.herokuapp.com/api/v1/upload/excel"
      );
    }
  }

  save(formData: FormData, url: string) {
    upload(formData, url)
      .then((x: AxiosResponse) => {
        this.isLoading = false;
        alert("Members added successfully !");
      })
      .catch((err: AxiosError) => {
        console.error(err);
        alert("An error has occurred! Please try again.");
      });
  }

  @Prop()
  label!: string;
}
